<div class="header-wrapper" [ngStyle]="{'marginBottom': mb}">
    <div class="title" [ngStyle]="{'lineHeight': lineHeight}">
        {{title}}
    </div>
    <div *ngIf="description" class="description">{{description}}</div>
</div>